
import {
    HiOutlineSquares2X2,
    HiOutlineUsers,
    HiOutlineCreditCard,
    HiOutlineBriefcase,
    HiOutlineShieldCheck,
    HiOutlineChatBubbleLeftRight,
    HiOutlineUserCircle,
    HiOutlineHeart,
    HiOutlineChatBubbleOvalLeftEllipsis,
    HiOutlineFlag,
    HiOutlinePresentationChartLine,
} from "react-icons/hi2";
import Dashboard from "../Pages/Dashboard";
import Users from "../Pages/Users/Users";
import CreateUser from "../Pages/Users/CreateUser";
import PreviewUser from "../Pages/Users/PreviewUser";
import EditUser from "../Pages/Users/EditUser";
import MemberView from "../Pages/Users/MemberView";
import MemberMatches from "../Pages/Users/MemberMatches";
import AdminMatchFinder from "../Pages/Users/AdminMatchFinder";
import Chat from "../Pages/Users/Chat";
import Plans from "../Pages/Plans/Plans";
import CreatePlan from "../Pages/Plans/CreatePlan";
import EditPlan from "../Pages/Plans/EditPlan";
import PendingUsers from "../Pages/Users/PendingUser";
import PlanValidity from "../Pages/Plans/PlanValidity";
import ManageImages from "../Pages/Users/ManageImages";
import Enquiries from "../Pages/Common/enquiries";
import Professions from "../Pages/Menus/Professions";
import AdminUsers from "../Pages/Admins/AdminUsers";
import Reports from "../Pages/Admins/Reports";
import Analytics from "../Pages/Admins/Analytics";

export const sideRoutes = [
    {
        link: '/dashboard',
        title: 'Dashboard',
        TitleIcon: HiOutlineSquares2X2,
        component: Dashboard,
    },
    {
        link: '/user',
        title: 'User',
        TitleIcon: HiOutlineUsers,
        component: Users
    },
    {
        link: '/matches',
        title: 'Find Matches',
        TitleIcon: HiOutlineHeart,
        component: AdminMatchFinder,
    },
    {
        link: '/chat',
        title: 'Chat',
        TitleIcon: HiOutlineChatBubbleOvalLeftEllipsis,
        component: Chat,
    },
    {
        link: '/plan',
        title: 'Plans',
        TitleIcon: HiOutlineCreditCard,
        component: Plans
    },
    {
        link: '/professions',
        title: 'Professions',
        TitleIcon: HiOutlineBriefcase,
        component: Professions
    },
    {
        link: '/planValidity',
        title: 'Plan Validity',
        TitleIcon: HiOutlineShieldCheck,
        component: PlanValidity
    },
    {
        link: '/enquiries',
        title: 'Enquiries',
        TitleIcon: HiOutlineChatBubbleLeftRight,
        component: Enquiries
    },
    {
        link: '/admins',
        title: 'Admins',
        TitleIcon: HiOutlineUserCircle,
        component: AdminUsers,
        allowedRoles: ['Super_Admin']
    },
    {
        link: '/reports',
        title: 'Reports',
        TitleIcon: HiOutlineFlag,
        component: Reports,
        allowedRoles: ['Super_Admin', 'Admin']
    },
    {
        link: '/analytics',
        title: 'Analytics',
        TitleIcon: HiOutlinePresentationChartLine,
        component: Analytics,
        allowedRoles: ['Super_Admin', 'Admin']
    },
]

export const OtherRoutes = [
    {
        title: 'Create User',
        link: '/createUser',
        component: CreateUser
    },
    {
        title: 'View User',
        link: "/view/:id",
        component: PreviewUser
    },
    {
        title: 'Edit User',
        link: "/edit/:id",
        component: EditUser
    },
    {
        title: 'Member View',
        link: "/member-view",
        component: MemberView
    },
    {
        title: 'Member View',
        link: "/member-view/:id",
        component: MemberView
    },
    {
        title: 'Create Plan',
        link: '/createPlan',
        component: CreatePlan
    },
    {
        title: 'Edit Plan',
        link: '/editPlan/:id',
        component: EditPlan
    },
    {
        title: 'Pending Users',
        link: '/user/:status',
        component: PendingUsers
    },
    {
        title: 'Manage Images',
        link: '/manageImages/:id',
        component: ManageImages
    },
    {
        title: 'Chat',
        link: '/chat/:userId',
        component: Chat,
    },
    {
        title: 'My Matches',
        link: '/my-matches',
        component: MemberMatches,
    },
]

export const CombinedRoutes = [...OtherRoutes, ...sideRoutes]
